import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replaceNbsp',
  standalone: false,
})
export class ReplaceNbspPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/&nbsp;/g, ' ');
  }
}
